<!-- CONTAINER -->
<div class="container content-area relative">
  <!-- PAGE-HEADER -->
  <div class="page-header">
    <h4 class="page-title">Edit Astrologer</h4>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a [routerLink]="['/admin/dashboard']">Home</a>
      </li>
      <li class="breadcrumb-item">
        <a [routerLink]="['/admin/astro/list']">List Astrologer</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">
        Edit Astrologer
      </li>
    </ol>
  </div>
  <!-- PAGE-HEADER END -->

  <!-- ROW-1 OPEN -->
  <div>
    <form [formGroup]="addAstrologerForm" (submit)="onAddAstrologerSubmit()" class="row" id="user-profile">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="accordion" id="accordionExample">
              <!-- Basic Information Section -->
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                    aria-expanded="true" aria-controls="collapseOne">
                    Basic Information
                  </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse show">
                  <div class="accordion-body">
                    <div class="row">
                      <!-- Display Name -->
                      <div class="col-lg-3 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Display Name</mat-label>
                          <input matInput placeholder="Display Name" formControlName="displayname" />
                          <mat-error *ngIf="f.displayname.invalid && (f.displayname.dirty || f.displayname.touched)">
                            Required. Only Characters are allowed
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <!-- Full Name -->
                      <div class="col-lg-3 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Full Name</mat-label>
                          <input matInput placeholder="Full Name" formControlName="name" />
                          <mat-error *ngIf="f.name.invalid && (f.name.dirty || f.name.touched)">
                            Required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <!-- Gender -->
                      <div class="col-lg-3 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Gender</mat-label>
                          <mat-select formControlName="gender">
                            <mat-option value="male">Male</mat-option>
                            <mat-option value="female">Female</mat-option>
                            <mat-option value="other">Other</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>

                      <!-- Date of Birth -->
                      <div class="col-lg-3 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Date of Birth : <small>MM/DD/YY</small> </mat-label>
                          <input matInput [matDatepicker]="picker" formControlName="dob"
                            placeholder="Select Date of Birth">
                          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                          <mat-error *ngIf="f.dob.invalid && (f.dob.dirty || f.dob.touched)">
                            Date of Birth is required
                          </mat-error>
                        </mat-form-field>

                      </div>
                    </div>

                    <div class="row">
                      <!-- Profile Image -->
                      <div class="col-lg-3 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Profile Image</mat-label>
                          <input matInput [value]="selectedFileName || 'No file chosen'" placeholder="Profile Image"
                            readonly (click)="fileInput.click()" />
                          <input #fileInput type="file" accept="image/*" (change)="onProfileImageUpload($event)"
                            hidden />
                          <button matSuffix mat-icon-button (click)="fileInput.click()" type="button">
                            <mat-icon>upload</mat-icon>
                          </button>
                          <mat-error
                            *ngIf="f.profile_image.invalid && (f.profile_image.dirty || f.profile_image.touched)">
                            Profile image is required
                          </mat-error>
                          <mat-error *ngIf="profileError !== ''">
                            {{ profileError }}
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <!-- Consultant Type -->
                      <div class="col-lg-3 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Consultant Type</mat-label>
                          <input matInput type="text" placeholder="Consultant Type" formControlName="consultant_type" />
                          <mat-error
                            *ngIf="f.consultant_type.invalid && (f.consultant_type.dirty || f.consultant_type.touched)">
                            Required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <!-- Working With Others -->
                      <div class="col-lg-3 col-md-12">




                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Working with other</mat-label>
                          <mat-select formControlName="working_with_other">
                            <mat-option [value]="'yes'">Yes</mat-option>
                            <mat-option [value]="'no'">No</mat-option>
                          </mat-select>
                        </mat-form-field>


                      </div>

                      <!-- Experience -->
                      <div class="col-lg-3 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Experience (in Years) <strong class="required-text">*</strong></mat-label>
                          <input matInput type="text" placeholder="Experience" formControlName="experience" />
                          <mat-error *ngIf="f.experience.invalid && (f.experience.dirty || f.experience.touched)">
                            Required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Contact Information Section -->
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    Contact Information
                  </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse show">
                  <div class="accordion-body">
                    <div class="row">
                      <!-- Country Code -->
                      <div class="col-lg-3 col-md-12">

                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Country Code</mat-label>
                          <mat-select formControlName="country_code">
                            <mat-option disabled value="">Select Country Code</mat-option>
                            <mat-option *ngFor="let country of countryCodes" [value]="country.phone_code">
                              {{ country.emoji }} {{ country.name }} (+{{ country.phone_code }})
                            </mat-option>

                          </mat-select>
                        </mat-form-field>

                      </div>

                      <!-- Contact Number -->
                      <div class="col-lg-3 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Contact Number</mat-label>
                          <input matInput placeholder="Phone number" formControlName="phone" />
                          <mat-error *ngIf="f.phone.invalid && (f.phone.dirty || f.phone.touched)">
                            Valid Phone Number Required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <!-- Alternate Number -->
                      <div class="col-lg-3 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Alternate Number</mat-label>
                          <input matInput type="text" placeholder="Alternate Number" formControlName="alternate_num" />
                          <mat-error
                            *ngIf="f.alternate_num.invalid && (f.alternate_num.dirty || f.alternate_num.touched)">
                            Valid Phone Number Required
                          </mat-error>
                          <mat-error
                            *ngIf="addAstrologerForm.errors?.identityRevealed && (addAstrologerForm.touched || addAstrologerForm.dirty)">
                            Contact Number cannot match Alternate Number
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <!-- Promotional Order To Take -->
                      <div class="col-lg-3 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Promotional Order To Take <strong class="required-text">*</strong></mat-label>
                          <input matInput type="text" placeholder="Promotional Order To Take"
                            formControlName="promocall_totake" />
                          <mat-error
                            *ngIf="f.promocall_totake.invalid && (f.promocall_totake.dirty || f.promocall_totake.touched)">
                            Required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Address Information Section -->
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    Address Information
                  </button>
                </h2>
                <div id="collapseThree" class="accordion-collapse collapse show">
                  <div class="accordion-body">
                    <div class="row">
                      <!-- Address -->
                      <div class="col-lg-4 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Address</mat-label>
                          <input matInput formControlName="complete_address" placeholder="Complete Address" />
                          <mat-error
                            *ngIf="f.complete_address.invalid && (f.complete_address.dirty || f.complete_address.touched)">
                            Address is required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <!-- City -->
                      <div class="col-lg-4 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>City</mat-label>
                          <input matInput type="text" placeholder="City" formControlName="city" />
                          <mat-error *ngIf="f.city.invalid && (f.city.dirty || f.city.touched)">
                            Required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <!-- State -->
                      <div class="col-lg-4 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>State</mat-label>
                          <input matInput formControlName="state" placeholder="State" />
                          <mat-error *ngIf="f.state.invalid && (f.state.dirty || f.state.touched)">
                            State is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="row">
                      <!-- Country -->
                      <div class="col-lg-4 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Country</mat-label>
                          <input matInput type="text" placeholder="Country" formControlName="country" />
                          <mat-error *ngIf="f.country.invalid && (f.country.dirty || f.country.touched)">
                            Required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <!-- Pin Code -->
                      <div class="col-lg-4 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Pin Code</mat-label>
                          <input matInput type="text" placeholder="Pin Code" formControlName="pincode" />
                          <mat-error *ngIf="f.pincode.invalid && (f.pincode.dirty || f.pincode.touched)">
                            Required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Professional Details Section -->
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    Professional Details
                  </button>
                </h2>
                <div id="collapseFour" class="accordion-collapse collapse show">
                  <div class="accordion-body">
                    <div class="row">
                      <!-- Skills -->
                      <div class="col-lg-6 col-md-12">

                        <ng-select [items]="skillsData" appearance="outline" bindLabel="skillname" bindValue="_id" [multiple]="true"
                          placeholder="Select Skills" formControlName="skill" class="w-100">
                        </ng-select>


                      </div>


                      <!-- Language Known -->
                      <div class="col-lg-6 col-md-12">
                        <ng-select placeholder="Select Languages" appearance="outline" [multiple]="true" formControlName="lang" class="w-100"
                          [items]="languageData" bindLabel="name" bindValue="_id">
                        </ng-select>
                      </div>




                    </div>
                  </div>
                </div>
              </div>

              <!-- Bank Details Section -->
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                    Bank Details
                  </button>
                </h2>
                <div id="collapseFive" class="accordion-collapse collapse show">
                  <div class="accordion-body">
                    <div class="row">
                      <!-- Bank Account Number -->
                      <div class="col-lg-4 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Bank Account Number</mat-label>
                          <input matInput type="text" placeholder="Bank Account Number"
                            formControlName="bank_account_num" />
                          <mat-error
                            *ngIf="f.bank_account_num.invalid && (f.bank_account_num.dirty || f.bank_account_num.touched)">
                            Required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <!-- Account Type -->
                      <div class="col-lg-4 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Account Type</mat-label>
                          <mat-select formControlName="account_type">
                            <mat-option value="savings">Saving</mat-option>
                            <mat-option value="current">Current</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>

                      <!-- Account Holder Name -->
                      <div class="col-lg-4 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Account Holder Name</mat-label>
                          <input matInput type="text" placeholder="Account Holder Name"
                            formControlName="account_holder_name" />
                          <mat-error
                            *ngIf="f.account_holder_name.invalid && (f.account_holder_name.dirty || f.account_holder_name.touched)">
                            Required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="row">
                      <!-- IFSC -->
                      <div class="col-lg-4 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>IFSC</mat-label>
                          <input matInput type="text" placeholder="IFSC" formControlName="ifsc" />
                          <mat-error *ngIf="f.ifsc.invalid && (f.ifsc.dirty || f.ifsc.touched)">
                            Required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Identification Documents Section -->
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                    Identification Documents
                  </button>
                </h2>
                <div id="collapseSix" class="accordion-collapse collapse show">
                  <div class="accordion-body">
                    <div class="row">
                      <!-- PAN Number -->
                      <div class="col-lg-4 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>PAN Number</mat-label>
                          <input matInput type="text" placeholder="PAN Number" formControlName="pan_number" />
                          <mat-error *ngIf="f.pan_number.invalid && (f.pan_number.dirty || f.pan_number.touched)">
                            Required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <!-- Aadhaar Number -->
                      <div class="col-lg-4 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Aadhaar Number</mat-label>
                          <input matInput type="text" placeholder="Aadhaar Number" formControlName="addhar_number" />
                          <mat-error
                            *ngIf="f.addhar_number.invalid && (f.addhar_number.dirty || f.addhar_number.touched)">
                            Required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <!-- Proof Image -->
                      <div class="col-lg-4 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Proof Image</mat-label>
                          <input matInput [value]="selectedProofFileName || 'No file chosen'" placeholder="Proof Image"
                            readonly (click)="proofFileInput.click()" />
                          <input #proofFileInput type="file" accept="image/*" (change)="onProofImageUpload($event)"
                            hidden />
                          <button matSuffix mat-icon-button (click)="proofFileInput.click()" type="button">
                            <mat-icon>upload</mat-icon>
                          </button>
                          <mat-error *ngIf="f.proof_image.invalid && (f.proof_image.dirty || f.proof_image.touched)">
                            Proof image is required
                          </mat-error>
                          <mat-error *ngIf="proofError !== ''">
                            {{ proofError }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Biography Section -->
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                    Biography
                  </button>
                </h2>
                <div id="collapseSeven" class="accordion-collapse collapse show">
                  <div class="accordion-body">
                    <div class="row">
                      <!-- Short Bio -->
                      <div class="col-lg-6 col-sm-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Short Bio</mat-label>
                          <textarea matInput formControlName="short_bio" placeholder="Description" rows="3"></textarea>
                          <mat-error *ngIf="f.short_bio.invalid && (f.short_bio.dirty || f.short_bio.touched)">
                            Required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <!-- Long Bio -->
                      <div class="col-lg-6 col-sm-12">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>About Me</mat-label>
                          <textarea matInput rows="3" formControlName="long_bio"
                            placeholder="My bio........."></textarea>
                          <mat-error *ngIf="f.long_bio.invalid && (f.long_bio.dirty || f.long_bio.touched)">
                            Required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer d-flex justify-content-center">
            <button type="submit" class="btn-form-custom col-4 btn btn-success mt-1">
              Save
            </button>

          </div>
        </div>
      </div>
      <!-- COL-END -->
    </form>
  </div>
  <!-- ROW-1 CLOSED -->
</div>
<!-- CONTAINER CLOSED -->
